/**
 * Class description
 *
 * Created: 2018-05-18
 * @author jonas
 */
import {IBetLineWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {StateMatrix} from "./StateMatrix";
import {BookOfShadowsGameConfig} from "../BookOfShadowsGameConfig";

export class SymbolUtil {
    public static createSymbolStateMatrixFromBetWins(betWinsData: IBetLineWinData[], noWinState: string, winState: string): StateMatrix<string> {
        let states: StateMatrix<string> = new StateMatrix<string>(BookOfShadowsGameConfig.instance.REELS_NUM, BookOfShadowsGameConfig.instance.SYMBOLS_NUM_IN_REEL[2], [0, BookOfShadowsGameConfig.instance.SYMBOLS_NUM_IN_REEL[2] - 1], noWinState);

        for (let i: number = 0; i < betWinsData.length; i++) {
            let betLineWinData: IBetLineWinData = <IBetLineWinData>betWinsData[i];

            for (let j: number = 0; j < betLineWinData.nrOfSymbols; j++) {
                states.setStateAt(j, betLineWinData.betLine[j], winState);
            }
        }
        return states;
    }
}